/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-self-assign */
import React, { useState } from "react";
import { withRouter, Link } from "react-router-dom";
import playGame from "../images/landing/playGame.svg";
import logo from "../images/logo.svg";
import twitter from "../images/twitter.svg";
import telegram from "../images/telegram.svg";
import yt from "../images/yt.svg";
import linkedin from "../images/in.svg";
import drop from "../images/drop.png";
import * as Scroll from "react-scroll";
import msg from "../images/msg.svg";
import band from "../images/band.svg";
import { getUserAddress } from "../web3Helper";
import { disconnectWallet, checkIsWalletConnected } from "../web3Utils";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import getWeb3 from "../web3Utils";
import copy from "../images/copy.svg";
import yellow from "../images/yellow.svg";
import fire from "../images/market/fire.gif";
import view from "../images/view.svg";
// import gate from "../images/gate.svg";
import pankake from "../images/pankake.svg";
// import bitmart from "../images/bitmart.svg";
let Links = Scroll.Link;

const Navbar = ({ history }) => {
  const [activeAccountAddress, setActiveAccountAddress] = React.useState("");
  const [address] = useState("0xe4c797d43631f4d660ec67b5cb0b78ef5c902532");
  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [isTrue, setTrue] = useState(false);
  React.useEffect(() => {
    getUserAddress().then((account) => setActiveAccountAddress(account));

    checkIsWalletConnected().then((isConnected) =>
      setIsWalletConnected(isConnected)
    );
  }, []);
  const CopyText = () => {
    toast.success("Address Copy to Clipboard");
  };
  const connectToNetwork = async () => {
    if (!activeAccountAddress) {
      const web3 = await getWeb3();
      const accounts = await web3.eth.getAccounts();
      setActiveAccountAddress(accounts[0]);
      window.location.href = window.location.href;
    }
  };

  const handleCopyText = () => {
    toast.success("Address Copy to Clipboard");
  };

  const handleDisconnectWallet = () => {
    disconnectWallet();
    window.location.href = window.location.href;
  };

  const path = history.location.pathname.split("/");
  return (
    <>
      <nav className="navbar first-bar  fixed-top navbar-toggleable-md navbar-expand-lg scrolling-navbar double-nav">
        <div className="sub">
          <div className="dex-div">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.dextools.io/app/bsc/pair-explorer/0x4c7de610b9cf3baef610abce5b7a53c4057a8008"
            >
              <img src={view} alt="" /> View BSC Chart here.
            </a>
          </div>
          <span></span>
          <div className="pan-div">
            <a className="pankake-img hide">Buy $MONS</a>
            <a
              target="_blank"
              rel="noreferrer"
              href=" https://pancakeswap.finance/swap?outputCurrency=0xe4c797d43631f4d660ec67b5cb0b78ef5c902532"
              className="pankake-img"
            >
              <img src={pankake} alt="" />
            </a>
            {/* <a
              target="_blank"
              rel="noreferrer"
              href=" https://www.bitmart.com/trade/en?symbol=MONS_USDT"
              className="pankake-img"
            >
              <img src={bitmart} alt="" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href=" https://www.gate.io/trade/MONS_USDT"
              className="pankake-img"
            >
              <img src={gate} alt="" />
            </a>

            <div className="dropdown  ">
            <button className="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Buy $MONS
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <Link className="dropdown-item" href="#">My Inventory</Link>
              <Link className="dropdown-item" to="/accumulation">My Accumulations</Link>
              <Link className="dropdown-item disconnect" href="#">Disconnect Wallet</Link>
            </div>
          </div> */}
          </div>
        </div>
      </nav>
      <nav className="navbar bar  fixed-top navbar-toggleable-md navbar-expand-lg scrolling-navbar double-nav">
        <div className="first-div">
          <div className="img-div">
            <p>FOLLOW US</p>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://medium.com/@monstersclan "
            >
              {" "}
              <img src={telegram} alt="" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://twitter.com/_Monstersclan"
            >
              {" "}
              <img src={twitter} alt="" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://t.me/MONSofficial"
            >
              <img src={msg} alt="" />
            </a>
            <a target="_blank" rel="noreferrer" href="http://t.me/MONS_Ann">
              <img src={band} alt="" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/@monstersclangame"
            >
              <img src={yt} alt="" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/company/monstersclan/"
            >
              <img src={linkedin} alt="" />
            </a>
          </div>

          <div className="drop-div">
            <button
              onClick={() => history.push("/game")}
              className="btn game buy"
            >
              <img src={playGame} alt="" /> PLAY NOW
            </button>
            {activeAccountAddress ? (
              <button
                className={"btn disable"}
                onClick={connectToNetwork.bind(null)}
              >
                {activeAccountAddress.substr(0, 6) +
                  "..." +
                  activeAccountAddress.substr(-4)}
                <CopyToClipboard
                  text={activeAccountAddress}
                  onCopy={handleCopyText}
                >
                  <img
                    className="copy ml-1"
                    width="17"
                    height="17"
                    src={copy}
                    alt=""
                  />
                </CopyToClipboard>
              </button>
            ) : (
              <button className={"btn"} onClick={connectToNetwork.bind(null)}>
                Connect Wallet
              </button>
            )}
          </div>
        </div>
      </nav>
      {!isTrue && (
        <p className="link-para">
          <span>Monster Clan offical Contract Address:</span>{" "}
          {address.substr(0, 10) + "......" + address.substr(-10)}{" "}
          <CopyToClipboard text={address} onCopy={CopyText}>
            <img className="copy" src={copy} alt="" />
          </CopyToClipboard>
        </p>
      )}
      <nav className="sec-nav navbar dark second-navbar fixed-top navbar-toggleable-md navbar-expand-lg navbar-light scrolling-navbar double-nav">
        <button
          className="navbar-toggler"
          onClick={() => setTrue(!isTrue)}
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="nav left  navbar-nav ml-auto">
            <li className="nav-item mob-view">
              <div className="dropdown">
                <button
                  className="btn"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img src={drop} alt="" />
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <Link className="dropdown-item" to="/inventory">
                    My Inventory
                  </Link>
                  <Link className="dropdown-item" to="/accumulation">
                    My Accumulations
                  </Link>
                  <Link className="dropdown-item disconnect" href="#">
                    Disconnect Wallet
                  </Link>
                </div>
              </div>
            </li>

            <li className="nav-item mob-view">
              {activeAccountAddress ? (
                <button
                  className={"btn disable connect"}
                  onClick={connectToNetwork.bind(null)}
                >
                  {activeAccountAddress.substr(0, 6) +
                    "..." +
                    activeAccountAddress.substr(-4)}
                  <CopyToClipboard
                    text={activeAccountAddress}
                    onCopy={handleCopyText}
                  >
                    <img
                      className="copy ml-1"
                      width="17"
                      height="17"
                      src={copy}
                      alt=""
                    />
                  </CopyToClipboard>
                </button>
              ) : (
                <button
                  className={"btn connect"}
                  onClick={connectToNetwork.bind(null)}
                >
                  Connect Wallet
                </button>
              )}
            </li>
            <li className="nav-item mob-view">
              <button
                onClick={() => history.push("/game")}
                className="btn game buy"
              >
                <img src={playGame} alt="" /> PLAY NOW
              </button>
            </li>

            <li className="nav-item ">
              <Links
                onClick={() => {
                  history.push("/");
                }}
                className="scroller"
                to="game"
                spy={false}
                smooth={true}
                offset={-130}
                duration={800}
              >
                {" "}
                Game Mechanics
              </Links>
            </li>

            <li className="nav-item ">
              <Links
                onClick={() => {
                  history.push("/");
                }}
                className="scroller"
                to="monster"
                spy={false}
                smooth={true}
                offset={-130}
                duration={800}
              >
                Monsters
              </Links>
            </li>
            <li className="nav-item ">
              <Link
                onClick={() => {
                  history.push("/binance-swap");
                }}
                className="scroller"
              >
                <img className="mr-1 binance-img" src={yellow} alt="" /> Binance
                NFT Swap
              </Link>
            </li>
          </ul>
          <ul className="right nav navbar-nav ml-auto">
            <li className="nav-item ">
              <Link
                className={`${path[1] === "market-place" ? "active-clr" : ""}`}
                to="/market-place/assets/monster"
              >
                Marketplace
              </Link>
            </li>
            {/* <li className="nav-item ">
              <Link to="/toknomics">Tokenomics</Link>
            </li> */}
            <li className="nav-item ">
              <Link
                className={`${path[1] === "staking" ? "active-clr" : ""}`}
                to="/staking"
              >
                <img src={fire} alt="" /> Staking
              </Link>
            </li>
          </ul>
        </div>
        <Link
          className="navbar-brand mx-auto d-block text-center order-0 order-md-1 w-25"
          to="/"
        >
          <img src={logo} alt="logo" />
        </Link>
        <div className="navbar-collapse collapse dual-nav w-50 order-2">
          <ul className="nav web navbar-nav mr-auto">
            <li className="nav-item">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://docs.google.com/forms/d/e/1FAIpQLSdVX-F9aWzEYKVPID-2UqQKHX-wUqWnLNRcUyCoCxKlOgM-Eg/viewform"
              >
                Beta Game
              </a>
            </li>
            <li className="nav-item first-item">
              <button className="btn coming">coming soon</button>
              <Link
                to="/market-place/assets/monster"
                className={`${path[1] === "market-place" ? "active-clr" : ""}`}
              >
                Marketplace
              </Link>
            </li>
            <li className="nav-item ">
              <Link
                className={`${path[1] === "staking" ? "active-clr" : ""}`}
                to="/staking"
              >
                <img src={fire} alt="" /> Staking
              </Link>
            </li>
          </ul>
          <div className="dropdown">
            <button
              className="btn"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img src={drop} alt="" />
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <Link className="dropdown-item" to="/inventory">
                My Inventory
              </Link>
              <Link className="dropdown-item" to="/accumulation">
                My Accumulations
              </Link>
              {isWalletConnected && (
                <Link
                  className="dropdown-item disconnect"
                  href="#"
                  onClick={() => handleDisconnectWallet()}
                >
                  Disconnect Wallet
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default withRouter(Navbar);
